import { useState, useEffect, useCallback } from 'react';
import { api } from '../api';

export function useRealtimeMetrics() {
  const [metrics, setMetrics] = useState<any>(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [lastUpdate, setLastUpdate] = useState<Date | null>(null);
  const [error, setError] = useState<string | null>(null);

  const fetchMetrics = useCallback(async () => {
    setIsUpdating(true);
    try {
      const data = await api.getDashboardMetrics();
      setMetrics(data);
      setLastUpdate(new Date());
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch metrics');
    } finally {
      setIsUpdating(false);
    }
  }, []);

  useEffect(() => {
    fetchMetrics();
    const interval = setInterval(fetchMetrics, 5000); // Update every 5 seconds
    return () => clearInterval(interval);
  }, [fetchMetrics]);

  const refresh = useCallback(() => {
    return fetchMetrics();
  }, [fetchMetrics]);

  return { metrics, isUpdating, lastUpdate, refresh, error };
}

export function useRealtimeData() {
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Fetch initial real-time data
    const fetchData = async () => {
      try {
        const response = await api.getDashboardMetrics();
        setData([response]);
      } catch (error) {
        console.error('Failed to fetch realtime data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  return { data, isLoading };
}
